import React, { useContext } from 'react';
import CartStatesModuleForm from '../Presentation/CartStatesModuleForm';
import CartStatesModuleInsideModal from '../Presentation/CartStatesModuleInsideModal';
import { UserOrderContext } from '../../../context/context';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
import CARTSTATE_MODULE_DATA from '../Data/SampleData';
import { isEmptyEvery } from '../../../common/utilities/utils';
import CART_STATES_CONSTANTS from '../Constants/CartStatesConstants';

export const CartStatesModule = props => {
  // get the context from parent
  const { unavailableItems, priceChangedItems, confirmChangesHandler, discardChangesHandler } = props;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { contentData = {} } = CARTSTATE_MODULE_DATA;
  const { FROMCONFIRM = '' } = CART_STATES_CONSTANTS;
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const dispositionOld = isEmptyEvery(userOrderState.dispositionOld)
    ? JSON.parse(localStorage.getItem('dispositionOld'))
    : userOrderState.dispositionOld;
  const { modalContent = {} } = contentData;
  const { CART_STATES_DATA, SET_DISPOSITION, DISPOSITION_METHOD, SCHEDULE_ORDER_DATA, SCHEDULE_ORDER_TIME_DATA } =
    START_ORDER_CONSTANTS;

  const closeCartModalHandler = () => {
    userOrderStateDispatch({
      type: SET_DISPOSITION,
      value: { oldvalue: dispositionOld, newValue: { ...dispositionOld } },
    });
    const { store, type, date, time, interval, deliveryAddress } = dispositionOld || {};
    discardChangesHandler(store, type, store?.summary?.menu?.catalogs[0]);
    userOrderStateDispatch({
      type: DISPOSITION_METHOD,
      value: { dispositionType: type },
    });
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: {
        showScheduleOrderCatering: false,
        selectedStoreInfo: store,
        deliveryAddress: deliveryAddress,
      },
    });
    let dateTimeObj = { time: time, interval: interval, date: date };
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_TIME_DATA,
      value: { selectedDateTime: dateTimeObj },
    });
    localStorage.setItem('dispositionType', type);
    localStorage.setItem('storeInfo', store);
    localStorage.setItem('dateTimeOrder', JSON.stringify(dateTimeObj));
    localStorage.setItem('dispositionOld', JSON.stringify(dispositionOld));
    localStorage.setItem('dispositionNew', JSON.stringify(dispositionOld));
    userOrderStateDispatch({ type: CART_STATES_DATA, value: { showCartModal: false } });
  };
  /**
   *
   * @param {*} type - defineds what type or order user has selected
   */
  const onCartStatesMethodSubmit = (event, type) => {
    event.stopPropagation();
    event.preventDefault();
    if (type === 'discardChanges') {
      closeCartModalHandler();
    } else {
      userOrderStateDispatch({
        type: SET_DISPOSITION,
        value: { oldvalue: dispositionNew, newValue: { ...dispositionNew } },
      });
      localStorage.setItem('dispositionOld', JSON.stringify(dispositionNew));
      localStorage.setItem('dispositionNew', JSON.stringify(dispositionNew));
      userOrderStateDispatch({ type: CART_STATES_DATA, value: { showCartModal: false } });
      confirmChangesHandler(FROMCONFIRM);
    }
  };

  /**
   *
   * @param {*} element - method to handle close of the modal
   */
  const handleClose = event => {
    event.stopPropagation();
    event.preventDefault();
    closeCartModalHandler();
  };

  const cartStatesModuleForm = (
    <CartStatesModuleForm
      modalContent={modalContent}
      onCartStatesMethodSubmit={onCartStatesMethodSubmit}
      unavailableItems={unavailableItems}
      priceChangedItems={priceChangedItems}
    />
  );
  return (
    <CartStatesModuleInsideModal handleClose={handleClose} CartStatesModuleForm={cartStatesModuleForm} />
  );
};

export default CartStatesModule;
